import React from 'react';
import Chart from 'react-apexcharts';

const BarChart = ({ title, categories, series, colors, horizontal = false, height = 350 }) => {
    const options = {
        chart: {
            type: 'bar',
            height: height,
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: horizontal,
            }
        },
        dataLabels: {
            enabled: false
        },
        colors: colors || ['#3B82F6'],
        xaxis: {
            categories: categories || [],
        }
    };

    return (
        <div className="bg-white p-4 rounded-lg shadow">
            {title && <h3 className="text-lg font-medium text-gray-900 mb-4">{title}</h3>}
            <Chart
                options={options}
                series={series || []}
                type="bar"
                height={height}
            />
        </div>
    );
};

export default BarChart;